import { render } from "./Popups.vue?vue&type=template&id=54e54e28"
import script from "./Popups.vue?vue&type=script&lang=js"
export * from "./Popups.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__